/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ガス契約情報
 */
export interface Szma301aResGasConInfoDto {
    /**
     * 託送供給依頼者小売事業者コード
     */
    tksIrishKoriCd?: string;
    /**
     * 託送供給依頼者小売事業者コード名称
     */
    tksirishRetailerCodeaname?: string;
    /**
     * 定格入力値（合計）
     */
    ratedinputvalueSum?: number;
    /**
     * プレミアム単価
     */
    premiumTanka?: number;
    /**
     * 熱量コード
     */
    heatcode?: string;
    /**
     * 熱量コード名称
     */
    heatcodeAname?: string;
    /**
     * エネルギー種別コード
     */
    energyClscode?: string;
    /**
     * エネルギー種別コード名称
     */
    energyClsfyCodeaname?: string;
    /**
     * あんしんパック対象コード
     */
    anshinpackTargetCode?: string;
    /**
     * あんしんパック対象コード名称
     */
    anshinpackTargetAname?: string;
    /**
     * 電気契約有無フラグ
     */
    electricitycontractEonflg?: string;
    /**
     * 電気契約有無フラグ名称
     */
    electricitycontractEonflgAname?: string;
    /**
     * 託送契約最大払出ガス量
     */
    consignmentcontractMaxExhaustgas?: string;
    /**
     * 託送契約年間託送供給量
     */
    consignmentcontractNknTakusosupply?: string;
    /**
     * 託送契約月別託送供給量１月
     */
    consignmentcontractMonthlytakusosupplyJan?: string;
    /**
     * 託送契約月別託送供給量２月
     */
    consignmentcontractMonthlytakusosupplyFeb?: string;
    /**
     * 託送契約月別託送供給量３月
     */
    consignmentcontractMonthlytakusosupplyMar?: string;
    /**
     * 託送契約月別託送供給量４月
     */
    consignmentcontractMonthlytakusosupplyApr?: string;
    /**
     * 託送契約月別託送供給量５月
     */
    consignmentcontractMonthlytakusosupplyMay?: string;
    /**
     * 託送契約月別託送供給量６月
     */
    consignmentcontractMonthlytakusosupplyJun?: string;
    /**
     * 託送契約月別託送供給量７月
     */
    consignmentcontractMonthlytakusosupplyJul?: string;
    /**
     * 託送契約月別託送供給量８月
     */
    consignmentcontractMonthlytakusosupplyAug?: string;
    /**
     * 託送契約月別託送供給量９月
     */
    consignmentcontractMonthlytakusosupplySep?: string;
    /**
     * 託送契約月別託送供給量１０月
     */
    consignmentcontractMonthlytakusosupplyOct?: string;
    /**
     * 託送契約月別託送供給量１１月
     */
    consignmentcontractMonthlytakusosupplyNov?: string;
    /**
     * 託送契約月別託送供給量１２月
     */
    consignmentcontractMonthlytakusosupplyDec?: string;
    /**
     * 冷房能力
     */
    reiboability?: number;
    /**
     * 発電容量
     */
    powergenerationcapacity?: number;
    /**
     * 空調対象フラグ
     */
    airconditioningTargetflag?: string;
    /**
     * 空調対象フラグ名称
     */
    airconditioningTargetflagAname?: string;
    /**
     * 機器定格対象フラグ
     */
    kikirateTargetflag?: string;
    /**
     * 機器定格対象フラグ名称
     */
    kikirateTargetflagAname?: string;
}

